import { Input, InputProps } from "reactstrap";

/**
 * Text input for numeric or decimal values.
 */

interface NumberInputProps extends Omit<InputProps, 'inputMode'> {
  inputMode?: 'numeric' | 'decimal';
}

const NumberInput = (props: NumberInputProps) => {
  const { inputMode = 'numeric', ...inputProps } = props;

  const pattern = inputMode === 'decimal' ? '^\\d*(\\.\\d+)?$' : '^[0-9]*$';

  return (
    <Input {...inputProps} type="text"
      inputMode={inputMode}
      pattern={pattern} />
  );
};

export default NumberInput;
